import { render, staticRenderFns } from "./ActivitiesListingMassModifyOwner.vue?vue&type=template&id=f42067e2&"
import script from "./ActivitiesListingMassModifyOwner.vue?vue&type=script&lang=js&"
export * from "./ActivitiesListingMassModifyOwner.vue?vue&type=script&lang=js&"
import style0 from "./ActivitiesListingMassModifyOwner.vue?vue&type=style&index=0&id=f42067e2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports